import Data from './data';
import axios from 'axios';
import global from './global';
import importExt from './federated-share/index';
import apiRobot from './api-robot';
import {
    utilTool,
    paramsSerializer,
    paramsSerializerV2,
    getQueryField,
    setQueryField,
    inPopDetailPage,
    UploadFile,
    UploadImage
} from './utils/index';
import uuidv4 from 'uuid/v4';
import { localLanguage, localCurrency } from '@/globalization/localData';

// 可能是被 iframe
let inCms = false;
let inCmsPageEditor = false;
try {
    inCmsPageEditor = inCms =
        !utilTool.inNode() && Boolean(window.top.cmsAppVm);
} catch (e) {
    inCms = true;
    inCmsPageEditor = false;
}

// // 与 cms 同源加载
// let inCmsOrigin = false;
// try {
//     inCmsOrigin = !utilTool.inNode() && Boolean(window.top.cmsAppVm);
// } catch (e) {
//     inCmsOrigin = false;
// }

let inCmsSetting = false;
try {
    inCmsSetting = window?.top?.location?.pathname === '/cmsnew/setting';
} catch (e) {
    inCmsSetting = false;
}
let supportWebp = null;

let inCmsUrl = '';
try {
    inCmsUrl = window.top.cmsAppVm && window.top.location.href;
} catch (e) {}

//保存了所有异步加载的js的promise
const scripts = {};
const styles = {};

// const readyConfig = {
//     isReady: false,
//     readyCallbacks: []
// };

// const detach = function() {
//     document.removeEventListener('DOMContentLoaded', completed, false);
//     window.removeEventListener('load', completed, false);
// };

// const completed = function() {
//     if (
//         document.addEventListener ||
//         event.type === 'load' ||
//         document.readyState === 'complete'
//     ) {
//         readyConfig.isReady = true;
//         detach();
//         for (let i = 0, len = readyConfig.readyCallbacks.length; i < len; i++) {
//             readyConfig.readyCallbacks[i]();
//         }
//     }
// };

// if (document.readyState === 'complete') {
//     readyConfig.isReady = true;
// } else {
//     document.addEventListener('DOMContentLoaded', completed, false);
//     window.addEventListener('load', completed, false);
// }

// const globalWheel = (function() {
//     let enabled;
//     let cacheScrollTop = -1;
//     const $html = document.body;
//     const onMouseWhell = function(evt) {
//         if (enabled !== false) return;
//         const elem = util.getScrollPelem(evt.target);
//         if (!elem || elem === this) {
//             evt.preventDefault();
//         } else {
//             const delta = evt.wheelDelta || -evt.detail;
//             if (delta < 0) {
//                 if (
//                     elem.scrollTop + elem.offsetHeight + 2 >=
//                     elem.scrollHeight
//                 ) {
//                     //scrollTop 可能不精准，+2 校正一下
//                     evt.preventDefault();
//                 }
//             } else {
//                 if (elem.scrollTop === 0) {
//                     evt.preventDefault();
//                 }
//             }
//         }
//     };
//     const onKeyDown = function(evt) {
//         if (enabled !== false) return;
//         const keyCode = evt.keyCode;
//         if (keyCode === 38 || keyCode === 40) {
//             evt.preventDefault();
//         }
//     };
//     const onScroll = function() {
//         if (cacheScrollTop !== -1 && cacheScrollTop !== $html.scrollTop) {
//             $html.scrollTop = cacheScrollTop;
//         }
//     };
//     const bindMousewheel = () => {
//         window.addEventListener('mousewheel', onMouseWhell, {
//             passive: false
//         });
//         window.addEventListener('DOMMouseScroll', onMouseWhell, false);
//         window.addEventListener('keydown', onKeyDown, false);
//         window.addEventListener('scroll', onScroll, false);
//     };

//     return {
//         enable() {
//             if (enabled) return false;
//             if (enabled === undefined) {
//                 bindMousewheel();
//             }
//             enabled = true;
//             cacheScrollTop = -1;
//         },
//         disable() {
//             if (enabled === false) return false;
//             if (enabled === undefined) {
//                 bindMousewheel();
//             }
//             enabled = false;
//             cacheScrollTop = $html.scrollTop;
//         }
//     };
// })();

const globalState = (function () {
    const list = [];

    function handlerState(evt) {
        for (let i = 0, len = list.length; i < len; i++) {
            util.call(list[i]);
        }
        const state = evt.state;
        if (state) {
            if (state.reload) {
                window.location.reload();
            } else {
                util.call(state);
            }
        }
    }
    window.onpopstate = handlerState;

    return {
        add(handler) {
            list.push(handler);
        }
    };
})();

let globalObserver;

// const IS_CHIME_URL = /^(cms-).*?chime\.me$/.test(window.location.hostname);
// const CMS_AJAX_PREFIX =
//     inCmsOrigin && !IS_CHIME_URL && !window.location.port ? '/cms-api' : '';

const util = {
    ...utilTool,
    topFixedHeight: 0,
    mapPs: null,
    inPopDetailPage: inPopDetailPage,
    // 一个单纯的Axios请求发送, 绕过了site里面的拦截器, 通常调用三方的接口可以用这个
    simpleAxios: axios.create({}),
    UploadFile,
    UploadImage,
    importExt,
    uuidv4,
    CLICK: utilTool.isMobile ? 'touchstart.polyfill' : 'click',
    inCms: inCms,
    inCmsSetting: inCmsSetting,
    inCmsUrl: inCmsUrl,
    inCmsPageEditor,
    scrollContainer: document.documentElement, // 全局滚动条所在的容器
    isSupportWebp() {
        try {
            return supportWebp == null
                ? (supportWebp =
                      Data.site &&
                      Data.site.webp &&
                      document
                          .createElement('canvas')
                          .toDataURL('image/webp')
                          .indexOf('data:image/webp') === 0)
                : Data.site && Data.site.webp && supportWebp;
        } catch (err) {
            return false;
        }
    },
    isMobileSize(size = 600) {
        return window.innerWidth <= size;
    },
    getHereMapPs() {
        if (!util.hereMapPs) {
            util.hereMapPs = util
                .addScript('//static.chimeroi.com/site/here-maps.js')
                .then(() => {
                    if (window.SiteVue) {
                        window.SiteVue.prototype.$EventBus.$emit('siteTrack', {
                            trackType: 'mapLoad'
                        });
                    }
                    let platform = new window.H.service.Platform({
                        apikey: Data.hereApiKey
                    });
                    return {
                        platform,
                        H: window.H
                    };
                });
        }
        return util.hereMapPs;
    },
    getMapPs() {
        if (!util.mapPs) {
            util.mapPs = util
                .addScript(
                    '//maps.googleapis.com/maps/api/js?key=' +
                        Data.suggestionKey +
                        '&libraries=places'
                )
                .then(() => {
                    if (window.SiteVue) {
                        window.SiteVue.prototype.$EventBus.$emit('siteTrack', {
                            trackType: 'mapLoad'
                        });
                    }
                    return window.google.maps;
                });
        }
        return util.mapPs;
    },
    /**
     * 页面ready函数对象,同jQuery的ready方法类似，参数是页面ready之后的执行函数
     * @param fn 函数
     */
    // ready(fn) {
    //     if (readyConfig.isReady) {
    //         fn();
    //     } else {
    //         readyConfig.readyCallbacks.push(fn);
    //     }
    // },
    /**
     * 执行函数对象
     * @param handler 函数对象
     * @param context 执行的上下文
     *
     * 所谓函数对象就是既可以是一个函数，也可以是一个对象，该对象具有如下属性：
     * {
     *      handler: 函数，字符串（该字符串是上下文对象的方法name）
     *      context: 上下文，选填
     *      args: 参数，选填
     * }
     * 从第三个参数开始后面的参数都将作为函数对象的执行参数，且放在函数对象内的args后面
     */
    call(handler, context) {
        if (!handler) return;
        try {
            let args = [].slice.call(arguments, 2);
            if (this.isFunction(handler)) {
                return handler.apply(context, args);
            } else {
                context = handler.context || context;
                args = (handler.args || []).concat(args);
                if (
                    this.isString(handler) ||
                    this.isString((handler = handler.handler))
                ) {
                    handler = context ? context[handler] : null;
                }
                if (this.isFunction(handler)) {
                    return handler.apply(context, args);
                }
            }
        } catch (err) {
            console.error('util.call', err);
            util.error(err, {
                info: 'Callback'
            });
        }
    },
    getQueryField: getQueryField,
    setQueryField: setQueryField,
    /**
     * 异步加载js脚本(一般情况下适用于加载一些第三方库的js, 如果是本项目的js代码, 请用require.ensure加载)
     *
     * @param {string} url 脚本链接地址
     * @returns 返回一个promise, 通过.then方法可以获取加载完成后的回调
     */
    addScript(url, async = true, crossorigin = false) {
        if (url) {
            if (async) {
                if (scripts[url]) {
                    //如果已经开始了异步加载,就返回加载的promise
                    return scripts[url];
                } else {
                    //否则开始加载
                    scripts[url] = new Promise(function (resolve) {
                        const script = document.createElement('script');
                        if (script.readyState) {
                            //IE
                            script.onreadystatechange = function () {
                                if (
                                    script.readyState === 'loaded' ||
                                    script.readyState === 'complete'
                                ) {
                                    script.onreadystatechange = null;
                                    resolve();
                                }
                            };
                        } else {
                            //Others
                            script.onload = function () {
                                resolve();
                            };
                        }
                        if (crossorigin === true) {
                            if (window.globalAlowCrossOrigin) {
                                script.setAttribute('crossorigin', 'anonymous');
                            }
                        } else if (util.isObject(crossorigin)) {
                            for (let name in crossorigin) {
                                if (crossorigin.hasOwnProperty(name)) {
                                    script.setAttribute(
                                        name,
                                        crossorigin[name]
                                    );
                                }
                            }
                        }
                        script.async = true;
                        script.src = url;
                        document && document.body.appendChild(script);
                    });
                    return scripts[url];
                }
            } else {
                const script = document.createElement('script');
                if (crossorigin === true && window.globalAlowCrossOrigin) {
                    script.setAttribute('crossorigin', 'anonymous');
                } else if (util.isObject(crossorigin)) {
                    for (let name in crossorigin) {
                        if (crossorigin.hasOwnProperty(name)) {
                            script.setAttribute(name, crossorigin[name]);
                        }
                    }
                }
                script.src = url;
                document && document.body.appendChild(script);
            }
        }
    },
    addStyle(css, async = true) {
        if (css) {
            let elem;
            if (css.indexOf('.css') !== -1) {
                if (styles[css] && async) {
                    return styles[css];
                } else if (
                    document.querySelector(`link[href="${css}"]`) &&
                    async
                ) {
                    return (styles[css] = new Promise(res => res()));
                } else {
                    elem = document.createElement('div');
                    elem.innerHTML =
                        '_<link rel="stylesheet" type="text/css" href="' +
                        css +
                        '"/>';
                }
            } else {
                elem = document.createElement('div');
                elem.innerHTML = '_<style type="text/css">' + css + '</style>';
            }
            elem = elem.lastChild;
            const head = document.getElementsByTagName('head')[0];
            if (async) {
                styles[css] = new Promise(function (resolve) {
                    elem.onload = function () {
                        resolve();
                    };
                    if (/trident/i.test(navigator.userAgent)) {
                        head.appendChild(elem);
                    } else {
                        global.timeout(() => {
                            head.appendChild(elem);
                        });
                    }
                });
                return styles[css];
            } else {
                head.appendChild(elem);
                return elem;
            }
        }
    },
    /**
     * 统一处理前进后退的方法，防止各处分别使用，容易覆盖
     */
    popstate(handler) {
        globalState.add(handler);
    },
    error(err, info) {
        if (util.call(window.globalErrorHandler, null, err, info) !== false) {
            // util.track().then(Track => {
            //     Track.sendSiteGa('Error', err.msg || err, JSON.stringify(info));
            // })
        }
    },
    indexOf(arr, value, name) {
        for (let i = 0, len = arr.length; i < len; i++) {
            if (arr[i][name] === value) return i;
        }
        return -1;
    },
    getObserver(target, callback) {
        if (!globalObserver) {
            globalObserver = new IntersectionObserver(
                function (entries) {
                    for (let i = 0, len = entries.length; i < len; i++) {
                        let entry = entries[i];
                        if (entry.isIntersecting) {
                            let target = entry.target;
                            if (target._observeCb) {
                                target._observeCb();
                                target._observeCb = null;
                            }
                            // if (target.module) {
                            //     target.module.$emit('visible');
                            //     target.module = null;
                            // }
                            globalObserver.unobserve(target);
                        }
                    }
                },
                { rootMargin: '0px' }
            );
        }
        if (target) {
            target._observeCb = callback;
            globalObserver.observe(target);
        }
        return globalObserver;
    },
    getStyle(el) {
        if (el.currentStyle) {
            return el.currentStyle;
        } else {
            return window.getComputedStyle(el, null);
        }
    },
    throttledRequest: () => {
        const CancelToken = axios.CancelToken;
        let source = null;
        let timer = null;
        return function (options) {
            if (source) {
                source.cancel();
            }
            if (timer) {
                clearTimeout(timer);
            }
            return new Promise((resolve, reject) => {
                timer = setTimeout(() => {
                    source = CancelToken.source();
                    options.cancelToken = source.token;
                    axios(options)
                        .then(res => resolve(res.data || res))
                        .catch(err => reject({ err, options }))
                        .finally(() => {
                            source = null;
                            timer = null;
                        });
                }, 200);
            });
        };
    },
    cloneData(data) {
        if (!data) {
            return data;
        }
        const newData = data.constructor === Array ? [] : {};
        for (let keys in data) {
            if (data.hasOwnProperty(keys)) {
                if (data[keys] && typeof data[keys] === 'object') {
                    newData[keys] = util.cloneData(data[keys]);
                } else {
                    newData[keys] = data[keys];
                }
            }
        }
        return newData;
    },
    deepClone(origin, copied = new WeakMap()) {
        if (typeof origin !== 'object' || !origin) return origin;
        let copy = {};
        if (util.isRegExp(origin)) {
            copy = new RegExp(origin);
            copy.lastIndex = 0;
            return copy;
        }
        if (util.isDate(origin)) return new Date(origin.valueOf());
        if (copied.has(origin)) return copied.get(origin);
        if (util.isArray(origin)) {
            copy = [];
        }
        copied.set(origin, copy);
        Object.keys(origin).forEach(key => {
            copy[key] = util.deepClone(origin[key], copied);
        });
        return copy;
    },
    clickBlank: el => {
        (el || document).dispatchEvent(new Event('click'));
    },
    /**
     * 统一处理定时器，防止页面中到处都是定时器，一个代码很乱，另一个影响性能，并且不好排查问题
     * @param handler
     *  添加定时器时，handler格式为：函数或对象
     * {
     *      handler: 函数对象,
     *      context: 函数执行上下文,
     *      args: 函数执行参数
     *      unique: 默认false, 是否唯一，判断依据为handler及context，保证同一函数不会创建重复定时器
     *      once: 默认true, 是否只会执行一次
     *      onfinish: 定时器函数执行完毕，返回值false或once为true时，都会执行该结束函数，用于处理循环定时器的回调
     *      single: 该定时器函数将独立执行，不与其他定时器函数一起执行，用于比较耗时的定时函数
     *      delay: 设置定时器延时
     *      trigger: 该定时函数是否立即先执行一次，多用于循环定时器函数
     * }
     *
     * eg:
     * util.timeout(function(){}) => 创建定时器
     * util.timeout('', true) => 移除定时器
     */
    timeout: global.timeout,
    scroll: global.scroll,
    winScrollTop: global.winScrollTop,
    destroy() {
        global.timeout(false);
        global.resize(false);
        global.scroll(false);
    },
    getScrollPelem(elem) {
        if (!elem || elem.nodeType !== 1 || elem === document.body) {
            return document.documentElement;
        }
        return util.getStyle(elem)['overflowY'] === 'auto'
            ? elem
            : util.getScrollPelem(elem.parentNode);
    },
    enableScroll(enable) {
        let $body = document.body;
        if ($body.classList.contains('overflow-hidden') !== enable)
            return false;
        let pr;
        if (enable) {
            $body.classList.remove('overflow-hidden');
            pr = 0;
        } else {
            $body.classList.add('overflow-hidden');
            pr = window.innerWidth - document.body.clientWidth;
        }
        $body.style.paddingRight = pr + 'px';
        if (!utilTool.isMobile) {
            global.resize('trigger');
        }
        // } else {
        //     return globalWheel[enable ? 'enable' : 'disable']();
        // }
    },
    scrollIntoView(ele, options) {
        ele.scrollIntoView(options);
        // if (
        //     options === undefined ||
        //     options === true ||
        //     options.block === 'start'
        // ) {
        //     var main = document.querySelector('.page-content');
        //     main.scrollTop -= util.topFixedHeight || 0;

        //     // const body = document.body;
        //     // const html = document.querySelector('html');
        //     // const topFixedHeight = util.topFixedHeight || 0;
        //     // const scrollTop = Math.max(html.scrollTop, body.scrollTop);
        //     // html.scrollTop = scrollTop - topFixedHeight - offset;
        //     // body.scrollTop = scrollTop - topFixedHeight - offset;
        // }
    },
    isOnView(ele) {
        const topFixedHeight = util.topFixedHeight || 0;
        const rect = ele.getBoundingClientRect();
        const winHeight = window.innerHeight;
        const eleHeight = rect.height;
        if (eleHeight === 0) {
            return false;
        }
        if ((winHeight - topFixedHeight) / 2 > eleHeight) {
            return rect.top - topFixedHeight >= 0 && rect.bottom <= winHeight;
        } else {
            return (
                rect.top <= (winHeight + topFixedHeight) / 2 &&
                rect.bottom > 0 &&
                rect.bottom > (winHeight + topFixedHeight) / 2
            );
        }
    },
    closest(ele, selector) {
        if (!ele) return null;
        let parentEle = ele.parentNode;
        if (!parentEle) return null;
        let selectorEles = [];
        while (!(selectorEles = parentEle.querySelectorAll(selector)).length) {
            ele = parentEle;
            parentEle = parentEle.parentNode;
            if (!parentEle) return null;
        }
        if (selectorEles.length) {
            for (let i = 0, len = selectorEles.length; i < len; i++) {
                const selectorEle = selectorEles[i];
                if (ele === selectorEle) {
                    return ele;
                }
            }
            return null;
        } else {
            return null;
        }
    },
    parentVmHas(vm, key) {
        let parentVm = vm.$parent;
        let flag = false;
        while ((flag = parentVm[key]) === undefined) {
            parentVm = parentVm.$parent;
            if (!parentVm) return false;
        }
        return flag;
    },
    toast(text, delay = 1500) {
        if (document) {
            let el = document.createElement('div');
            el.className = 'toast';
            el.innerHTML = text;
            document && document.body.appendChild(el);
            util.timeout({
                handler: () => {
                    document.body.removeChild(el);
                },
                delay: delay,
                unique: true
            });
        }
    },
    login(option) {
        return import('../components/sign-log').then(signLog => {
            signLog.default.login(null, option);
        });
    },
    register(option) {
        return import('../components/sign-log').then(signLog => {
            signLog.default.register(null, option);
        });
    },
    getUserActionPs() {
        if (!util.userActionPs) {
            util.userActionPs = Promise.resolve();
            util.userActionPs = new Promise(res => {
                const removeEvent = function () {
                    window.removeEventListener(
                        'mousemove',
                        onUserAction,
                        false
                    );
                    window.removeEventListener('touchstart', onUserAction, {
                        passive: true
                    });
                    window.removeEventListener('touchmove', onUserAction, {
                        passive: true
                    });
                    window.removeEventListener('scroll', onUserAction, false);
                    window.removeEventListener('wheel', onUserAction, {
                        passive: true
                    });
                };
                const onUserAction = function () {
                    removeEvent();
                    res();
                };
                window.addEventListener('mousemove', onUserAction, false);
                window.addEventListener('touchstart', onUserAction, {
                    passive: true
                });
                window.addEventListener('touchmove', onUserAction, {
                    passive: true
                });
                window.addEventListener('scroll', onUserAction, false);
                window.addEventListener('wheel', onUserAction, {
                    passive: true
                });
            });
        }
        return util.userActionPs;
    },
    isObjectSame(obj, compareObj, strit = false, excludeKeys = []) {
        if (strit) {
            return JSON.stringify(obj) === JSON.stringify(compareObj);
        } else {
            let flag = false;
            const keys = Object.keys(obj || {}).sort();
            const compareKeys = Object.keys(compareObj || {}).sort();
            if (JSON.stringify(keys) === JSON.stringify(compareKeys)) {
                let newFlag = true;
                keys.forEach(key => {
                    if (!excludeKeys.includes(key)) {
                        if (typeof obj[key] === 'object') {
                            if (
                                !util.isObjectSame(
                                    obj[key],
                                    compareObj[key],
                                    false,
                                    excludeKeys
                                )
                            ) {
                                newFlag = false;
                            }
                        } else {
                            if (obj[key] !== compareObj[key]) {
                                newFlag = false;
                            }
                        }
                    }
                });
                if (newFlag) {
                    flag = true;
                }
            }
            return flag;
        }
    },
    isObjectSameSafe(obj, compareObj, strit = false, excludeKeys = []) {
        try {
            return util.isObjectSame(obj, compareObj, strit, excludeKeys);
        } catch (e) {
            return false;
        }
    },
    getVisibilityChangeName() {
        let visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            visibilityChange = 'visibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
            visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
            visibilityChange = 'webkitvisibilitychange';
        }
        return visibilityChange;
    },
    isPageHidden() {
        if ('hidden' in document) {
            return true;
        }
        var prefixes = ['webkit', 'moz', 'ms', 'o'];
        for (var i = 0; i < prefixes.length; i++) {
            if (prefixes[i] + 'Hidden' in document) {
                return true;
            }
        }
        return false;
    },
    // Calculate the four points of the rectangle
    // based on the latitude, longitude and radius
    getRectangle(lat, lon, radius = 10) {
        const distance = 0.0091 * radius;
        const tlLat = lat + distance;
        const tlLonDistance = distance / Math.cos((tlLat * Math.PI) / 180);
        const tlLon = lon + (lon > 0 ? tlLonDistance : -tlLonDistance);
        const brLat = lat - distance;
        const brLonDistance = distance / Math.cos((brLat * Math.PI) / 180);
        const brLon = lon - (lon > 0 ? brLonDistance : -brLonDistance);
        return [tlLat, tlLon, brLat, brLon];
    },
    parseJSON(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            console.error(e);
        }
        return null;
    },
    googleTranslateor(value) {
        import('./translate/googleTranslatePlugin').then(module => {
            module.default(value);
        });
    },

    // 用于 gtag 初始化的时候不支持 Date 类型
    initGtag() {
        let gtag = window.gtag;
        if (gtag) {
            gtag('js', new Date());
        }
    },
    transformLink2WordPress(link) {
        /*wordpress中listing-detail需要去掉md-header和md-footer*/
        if (Data.wordPressSSR) {
            // https://site6.chime.me/listing-detail/{id}/{name}
            const reg =
                /(https?\:\/\/)?([^\/]*)?(\/listing-detail(\/\d+)(\/[^?]*))/;
            // // const key = 'wordPressSSR=1';
            // let [path, params] = link.split('?');
            // path = path.replace('/listing-detail', '');
            // params = window.decodeURIComponent(params);
            // params = window.encodeURIComponent(
            //     window.encodeURIComponent(params)
            // );
            // const paramsLink = `/listing-detail?q_data=${path}%3F${params}`;
            // return paramsLink;
            return link.match(reg)[0];
        } else {
            return link;
        }
    },
    formatMaxValue(val, type = 'max') {
        if (!val) return val;
        let date = new Date(+val);
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? `${month}` : `0${month}`;
        const day = date.getDate();
        const time = type === 'max' ? '23:59:59' : '00:00:00';
        return new Date(`${year}/${month}/${day} ${time}`).getTime() + '';
    },
    getTimeZone() {
        const zoneOffset = new Date().getTimezoneOffset() / -60;
        let zone;
        if (zoneOffset >= 0) {
            zone = zoneOffset >= 10 ? `+${zoneOffset}00` : `+0${zoneOffset}00`;
        } else {
            zone =
                zoneOffset <= -10
                    ? `-${Math.abs(zoneOffset)}00`
                    : `-0${Math.abs(zoneOffset)}00`;
        }
        return `GMT${zone}`;
    },
    transferPriceToDollar({ price, isInt }) {
        if (!price) {
            return '';
        }
        // 转成美元, 即除以汇率currencyRate
        const currencyRate = Data.currencyRate || 1;
        if (isInt) {
            return parseInt(Number(price) / Number(currencyRate));
        }
        return Number(price) / Number(currencyRate);
    },
    transferDollarToCurrency({ price, isInt }) {
        if (!price) {
            return '';
        }
        // 美元转成当前货币, 即乘以汇率currencyRate
        const currencyRate = Data.currencyRate || 1;
        if (isInt) {
            return parseInt(Number(price) * Number(currencyRate));
        }
        return Number(price) * Number(currencyRate);
    }
};
window.Util = new Proxy(util, {
    get: function (target, property) {
        var raw = target[property];
        if (property === 'isMobile') {
            if (inCms) {
                // cms中只要屏幕宽度小于600, 就认为是移动端
                return (
                    raw ||
                    (document.documentElement &&
                        document.documentElement.clientWidth <= 600)
                );
            }
        }
        return raw;
    }
});

if (utilTool.isMobile) {
    document.body.classList.add('mobile');
}

//request数据缓存
export const requestCache = (window.requestCache = {
    data: {},
    requestPromise: {},
    requestResolve: {},
    set(key, data) {
        this.data[key] = util.deepClone(data);
    },
    get(key, isUrl = false) {
        if (isUrl) {
            const urlKey = buildKey(key);
            return this.data[urlKey];
        } else {
            return this.data[key];
        }
    },
    delete(key, isUrl = false) {
        if (isUrl) {
            const urlKey = buildKey(key);
            delete this.data[urlKey];
        } else {
            delete this.data[key];
        }
    },
    clear() {
        this.data = {};
    }
});

//建立唯一的key值
export function buildKey(url, params = {}) {
    if (url.indexOf('?') !== -1) {
        let strParams = url.substr(url.indexOf('?') + 1);
        url = url.substr(0, url.indexOf('?'));
        strParams = decodeURIComponent(strParams).split('&');
        for (let i = 0, len = strParams.length; i < len; i++) {
            const nv = strParams[i].split('=');
            params[nv[0]] = nv[1];
        }
    }
    const sortedParams = Object.keys(params)
        .sort()
        .reduce((result, key) => {
            result[key] = params[key];
            return result;
        }, {});
    const key = url + `-${JSON.stringify(sortedParams)}`;
    return key;
}

const defaultsAdapter = axios.defaults.adapter,
    regGraphQL = /\/api-graphql/,
    regMutation = /mutation/;

const noCacheUrls = ['/api-site/logout'];

axios.defaults.timeout = 20000;

axios.defaults.adapter = config => {
    let configData = config.data;
    if (typeof configData === 'string') {
        configData = JSON.parse(configData);
    }
    if (regGraphQL.test(config.url)) {
        config.url = '/api-graphql/' + formatGraphQlQuery(configData.query);
    }
    if (
        !utilTool.inNode() &&
        window.sitePageAutoInit !== false &&
        !config.noCache &&
        !noCacheUrls.includes(config.url) &&
        (config.method === 'get' ||
            (regGraphQL.test(config.url) &&
                !regMutation.test(configData.query)))
    ) {
        const key = buildKey(config.url, config.params || configData);
        const data = requestCache.get(key);
        if (data) {
            return Promise.resolve(JSON.parse(JSON.stringify(data)));
        } else if (requestCache.requestPromise[key]) {
            return requestCache.requestPromise[key];
        } else {
            requestCache.requestPromise[key] = new Promise(resolve => {
                requestCache.requestResolve[key] = resolve;
            });
        }
    }
    return defaultsAdapter(config);
};

function formatGraphQlQuery(query) {
    let reg = /{|}/gm,
        fmt = [],
        rt,
        from = -1,
        count = 0;
    query = query.replace(/(\:[^(]+)?\(([^")]+|(\"[^"]*\"))+\)|\r?\n|,/gm, '');
    rt = reg.exec(query);
    while (rt) {
        count += rt[0] === '{' ? 1 : -1;
        if (count === 1) {
            from = rt.index + 1;
        } else if (from !== -1) {
            let str = query.substring(from, rt.index).trim();
            if (str) {
                fmt.push(str);
            }
            from = -1;
        }
        rt = reg.exec(query);
    }
    return fmt.join('-');
}

const CancelToken = axios.CancelToken;
axios.interceptors.request.use(
    config => {
        if (
            utilTool.isReallyUser &&
            apiRobot({ url: config.url, method: config.method })
        ) {
            const source = CancelToken.source();
            config.cancelToken = source.token;
            source.cancel(`robot cancel: ${config.url}`);
            return config;
        }
        // 正在服务端渲染时的请求baseUrl
        if (util.inNode()) {
            config.baseURL = Data.$origin;
            // node上site请求数据保持登录态
            if (config.headers && Data.$headers['cookie']) {
                config.headers.Cookie = Data.$headers['cookie'];
            }
            // console.log(config.baseURL, config.url, config.headers.Cookie);
        }
        /**
         *  widget ssr在site请求时的baseUrl
         *  添加/chime-widget前缀
         * */
        if (!util.inNode() && !Data.widget && Data.shortCode) {
            const prefix = '/chime-widget';
            config.baseUrl = prefix;
        }

        /**
         * ssr客户端激活添加请求头 ssr= 1
         */
        if (Data.$origin) {
            const customSSRHeader = { ssr: '1' };
            config.headers =
                'headers' in config
                    ? Object.assign(config.headers, customSSRHeader)
                    : customSSRHeader;
        }

        let url = config.url;
        if (inCms && /^\//.test(url)) {
            //cdn文件,资源文件,都不应该带这个头
            config.headers['Including-Inactive-Mls'] = true;
        }
        if (
            /\/search\/realTimeListings/.test(url) &&
            Array.isArray(config.params && config.params.avgTypes)
        ) {
            config.paramsSerializer = paramsSerializerV2;
        } else {
            config.paramsSerializer = paramsSerializer;
        }
        if (/^\//.test(url)) {
            let siteId = Data.siteId,
                dataId = Data.dataId;
            if (siteId) {
                config.headers.CURRENTSITEID = siteId;
            }
            if (dataId) {
                config.headers.CURRENTDATAID = dataId;
            }
            config.headers.CURRENTLANGUAGE = localLanguage.get();
            config.headers['currency-unit'] = localCurrency.get();
            config.headers['site-search-listings'] = true;
        }

        return config;
    },
    error => {
        writeLog(
            Data.$errorLog,
            'Request Error',
            error.errorInfo.config.url,
            'error'
        );
        console.error(error);
    }
);

axios.interceptors.response.use(
    res => {
        let resConfigData = res.config.data;
        if (typeof resConfigData === 'string') {
            resConfigData = JSON.parse(resConfigData);
        }
        if (
            window.sitePageAutoInit !== false &&
            !noCacheUrls.includes(res.config.url) &&
            (res.config.method === 'get' ||
                (regGraphQL.test(res.config.url) &&
                    !regMutation.test(resConfigData.query)))
        ) {
            const key = buildKey(
                res.config.url,
                res.config.params || resConfigData
            );
            if (!requestCache.get(key)) {
                requestCache.set(key, res);
                requestCache.requestResolve[key] &&
                    requestCache.requestResolve[key](
                        JSON.parse(JSON.stringify(res))
                    );
                delete requestCache.requestPromise[key];
                delete requestCache.requestResolve[key];
            }
        }
        if (res.data) {
            if (typeof res.data === 'object' && !res.data.__config__) {
                Object.defineProperty(res.data, '__config__', {
                    get() {
                        return res.config;
                    },
                    enumerable: false
                });
            }
            if (
                res.data.status &&
                typeof res.data.status == 'object' &&
                res.data.status.code !== 0
            ) {
                if (window.SiteVue) {
                    window.SiteVue.prototype.$EventBus.$emit('siteTrack', {
                        trackType: 'request-fail',
                        requestInfo: res,
                        error: false
                    });
                }

                writeLog(
                    Data.$errorLog,
                    'Response Error',
                    res.config.url,
                    'error'
                );
                return Promise.reject({
                    error: false,
                    errorInfo: res.data.status.msg || '',
                    code: res.data.status.code
                });
            }
            writeLog(Data.$log, res.config.url, 'Success', 'info');
            return res.data;
        } else if (
            // 该逻辑修复图片上传无返回结果导致误认为失败的问题,参考 cms 拦截器
            /aws/.test(res.config.url) &&
            res.config.method === 'put' &&
            res.status === 200
        ) {
            if (typeof res.data === 'object') {
                res.data.__config__ = res.config;
            }

            return res.data;
        } else {
            // 此处无逻辑
        }
        if (window.SiteVue) {
            window.SiteVue.prototype.$EventBus.$emit('siteTrack', {
                trackType: 'request-fail',
                requestInfo: res,
                error: false
            });
        }

        writeLog(Data.$errorLog, 'Response Error', res.config.url, 'error');
        return Promise.reject({
            error: false,
            errorInfo: res
        });
    },
    error => {
        if (axios.isCancel(error)) {
            requestCache.requestPromise = {};
            requestCache.requestResolve = {};
            writeLog(
                Data.$errorLog,
                'Request Canceled',
                error.message || '',
                'error'
            );
            return Promise.reject({
                error: false,
                errorInfo: 'Request canceled: ' + error.message || ''
            });
        } else {
            let config = error.config || {};
            let resConfigData = config.data;
            if (typeof resConfigData === 'string') {
                resConfigData = JSON.parse(resConfigData);
            }
            if (
                config.method === 'get' ||
                (regGraphQL.test(config.url) &&
                    !regMutation.test(resConfigData.query))
            ) {
                const key = buildKey(
                    config.url,
                    config.params || resConfigData
                );
                requestCache.requestResolve[key] &&
                    requestCache.requestResolve[key](error);
                delete requestCache.requestPromise[key];
                delete requestCache.requestResolve[key];
            }
            if (window.SiteVue) {
                window.SiteVue.prototype.$EventBus.$emit('siteTrack', {
                    trackType: 'request-fail',
                    requestInfo: error,
                    error: true
                });
            }
            writeLog(
                Data.$errorLog,
                'Response Error',
                `${config.url} [${config.method}]`,
                'error'
            );
            return Promise.reject({
                error: true,
                errorInfo: error
            });
        }
    }
);

// for lighthouse
axios.interceptors.response.use(res => {
    const isReallyUser = utilTool.isReallyUser;
    if (isReallyUser) return res;
    const config = res.__config__;
    const searchDateReg = /api-site\/search\/search-data/;
    const houseListReg = /api-site\/search\/realTimeListings/;
    if (config && searchDateReg.test(config.url)) {
        const data = res.data;
        if (!data) return res;
        // const configs = data.configs; // search center
        const customizedCity = data.customizedCity;
        const more = data.more;
        const propertyConfigs = data.propertyConfigs;
        const searchCharts = data.searchCharts;
        // if (Array.isArray(configs)) {
        //     configs[0].conditions = configs[0].conditions.slice(0, 4);
        //     data.configs = configs.slice(0, 1);
        // }
        if (Array.isArray(customizedCity)) {
            data.customizedCity = [];
        }
        if (Array.isArray(more)) {
            data.more = [];
        }
        if (Array.isArray(propertyConfigs)) {
            data.propertyConfigs = data.propertyConfigs.slice(0, 3);
        }
        if (Array.isArray(searchCharts)) {
            data.searchCharts = [];
        }
    }

    // && config.params.timeline === true
    if (config && houseListReg.test(config.url) && config.params) {
        res.listings = Object.freeze(res.listings.slice(0, 2));
    }
    writeLog(
        Data.$errorLog,
        'In Lighthouse Axios Response Interceptor',
        'error'
    );
    return res;
});

let siteLog;
function writeLog(log, message, url, type) {
    if (util.inNode()) {
        if (!siteLog) {
            siteLog = log;
        }
        const method = type === 'error' ? 'error' : 'info';
        siteLog[method](`${message}${url ? ' - ' + url : ''}`);
    }
}

util.getUserActionPs();
window.siteAxios = axios;

export default window.Util;
